import { yupResolver } from "@hookform/resolvers/yup";
import { CodeSoftphoneEnum, ModalParamsType } from "models";
import { useProfile } from "providers";
import { useCallback, useMemo, useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { SelectProjectSchema } from "utils";

export default function SelectProjectViewModel({
  open,
  onClose,
}: ModalParamsType) {
  const [selectProject, setSelectProject] = useState<number>();
  const {
    reset,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(SelectProjectSchema),
  });
  const profile = useProfile();
  const { pIdProject, pIdSoftphone, projectOpts } = profile;
  const { onChangeProject } = profile;
  const { t } = useTranslation("modals");
  const navigate = useNavigate();

  const codeSoftphoneOpts = useMemo(
    () => [
      {
        codeSoftphone: CodeSoftphoneEnum.ByProject,
        label: t("selectSoftphone.byProject"),
      },
      {
        codeSoftphone: CodeSoftphoneEnum.ByUser,
        label: t("selectSoftphone.byUser"),
      },
    ],
    [t],
  );

  const hasSoftphoneSelect = useMemo(() => {
    const current = projectOpts?.find(
      ({ IdProject }) => IdProject === selectProject,
    );

    return current?.MustSelectSoftphone;
  }, [selectProject, projectOpts]);

  const onOpen = useCallback(() => {
    if (!open) return;

    reset();
    setSelectProject(pIdProject);
    pIdProject && setValue("project", pIdProject);
    pIdSoftphone && setValue("softphone", pIdSoftphone);
  }, [open, pIdProject, pIdSoftphone, reset, setValue]);

  const changeSelectProject = useCallback(
    (value: number) => {
      setSelectProject(value);
      setValue("project", value);
    },
    [setValue],
  );

  const submit: SubmitHandler<typeof SelectProjectSchema.__outputType> =
    useCallback(
      ({ project, softphone }) => {
        onChangeProject(project, softphone);
        navigate("/");
        onClose();
      },
      [onChangeProject, navigate, onClose],
    );

  return {
    errors,
    selectProject,
    pIdProject,
    pIdSoftphone,
    projectOpts,
    codeSoftphoneOpts,
    hasSoftphoneSelect,
    t,
    onOpen,
    setValue,
    changeSelectProject,
    onSubmit: handleSubmit(submit),
  };
}
